import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { bindActionCreators } from 'redux';

import DevTools from './config/devtools';
import initStore from './config/store';
import setupAxiosInterceptors from './config/axios-interceptor';
import { clearAuthToken } from './shared/reducers/authentication';
import ErrorBoundary from './shared/error/error-boundary';
import AppComponent from './app';
import { loadIcons } from './config/icon-loader';
import { Storage, TranslatorContext } from 'react-jhipster';

const devTools = process.env.NODE_ENV === 'development' ? <DevTools /> : null;

const store = initStore();

const actions = bindActionCreators({ clearAuthToken }, store.dispatch);
setupAxiosInterceptors(() => actions.clearAuthToken);

loadIcons();

// Initialize translations
const currentLocale = Storage.local.get('locale', 'en');
TranslatorContext.setDefaultLocale('en');

// Dynamic translation loader
const timestamp = new Date().getTime(); // Cache-busting
const loadAndRegisterTranslations = async () => {
  try {
    // Define all translation namespaces (files) to load
    const translationModules = [
      'global',
      'home',
      'symptom',
      'driver',
      'healthcare-facility',
      'payment',
      'physician',
      'vehicle-type',
      'route',
      'village',
      'watotocare-entity',
      'patient',
      'patient-baby',
      'patient-visit',
      'patient-outcome',
      'journey',
      'watotocare-settings',
      'user-management',
      'account',
      'common',
    ];

    const translations = {};

    // Dynamically import and merge all translation files for the current locale
    await Promise.all(
      translationModules.map(async module => {
        try {
          const moduleData = await import(`../i18n/${currentLocale}/${module}.json`);
          Object.assign(translations, moduleData.default);
        } catch (err) {
          console.warn(`Failed to load translation file: ${currentLocale}/${module}.json`, err);
        }
      })
    );

    console.log(`Loaded ${currentLocale.toUpperCase()} translations:`, translations);
    TranslatorContext.registerTranslations(currentLocale, translations);
    TranslatorContext.setLocale(currentLocale);

    // Set HTML lang attribute
    document.querySelector('html').setAttribute('lang', currentLocale);
  } catch (error) {
    console.error(`Failed to load translations for locale: ${currentLocale}`, error);

    // Fallback to default locale if translation loading fails
    if (currentLocale !== 'en') {
      console.warn('Falling back to default locale (en)');
      Storage.local.set('locale', 'en');
      window.location.reload();
    }
  }
};

// Load translations
loadAndRegisterTranslations();

const rootEl = document.getElementById('root');

const render = Component =>
  // eslint-disable-next-line react/no-render-return-value
  ReactDOM.render(
    <ErrorBoundary>
      <Provider store={store}>
        <div>
          {/* If this slows down the app in dev disable it and enable when required  */}
          {/* {devTools} */}
          <Component />
        </div>
      </Provider>
    </ErrorBoundary>,
    rootEl
  );

render(AppComponent);
